import { AxiosResponse } from "axios";
import { InjectableService } from "@/shared/services/InjectableService";
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { QueueNCAAnalysisArgs } from "@/shared/Executions/models/QueueNCAAnalysisArgs";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { GetAnalysisConfigArgs } from "../models/GetAnalysisConfigArgs";
import { AnalysisConfig } from "../models/AnalysisConfig";
import { GetExecutionConfigArgs } from "@/shared/Executions/models/GetExecutionConfigArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";

export interface IAnalysisConfigsApiService {
  processAnalysisConfigs: (userId: string, tenantId: string, args: QueueNCAAnalysisArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
  getAnalysisConfig: (args: GetAnalysisConfigArgs) => Promise<AnalysisConfig>
}

export class AnalysisConfigApiService extends InjectableService implements IAnalysisConfigsApiService {

  static readonly injectableKey = 'IAnalysisConfigsApiService';

  get injectableKey() {
    return (this.constructor as typeof AnalysisConfigApiService).injectableKey;
  }

  constructor(private readonly _executionApiService: IExecutionApiService) {
    super()
  }

  public async processAnalysisConfigs(userId: string, tenantId: string, args: QueueNCAAnalysisArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

    const queueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, ncaAnalysisArgs: args });

    return await this._executionApiService.queueExecution(queueExecutionArgs);

  }

  /**
  * @deprecated TBD if we should remove as PK Analysis Executions have their JSON loaded directly via ExecutionApiService.
  */
  public async getAnalysisConfig(args: GetAnalysisConfigArgs): Promise<AnalysisConfig> {

    const getExecutionConfigArgs = new GetExecutionConfigArgs({ userId: args.userId, tenantId: args.tenantId, executionId: args.executionId });

    const getExecutionConfigReponse = await this._executionApiService.getExecutionConfig(getExecutionConfigArgs);

    return getExecutionConfigReponse?.data?.calculation!;

  }

}
